import { render, staticRenderFns } from "./Colour.vue?vue&type=template&id=6ec34add&scoped=true&"
import script from "./Colour.vue?vue&type=script&lang=js&"
export * from "./Colour.vue?vue&type=script&lang=js&"
import style0 from "./Colour.vue?vue&type=style&index=0&id=6ec34add&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec34add",
  null
  
)

export default component.exports